import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { obtenerHistorialSolicitud } from "../services/historial-solicitud-service";

/**
 * QueryOptions del historial de una solicitud (Temporal Tables).
 * Sin staleTime corto · el historial es immutable (rows pasadas no cambian),
 * solo se agregan rows nuevas cuando hay updates. 60s es suficiente.
 */
export const historialSolicitudQueryOptions = (id: string) =>
  queryOptions({
    queryKey: qk.historialSolicitud(id),
    queryFn: () => obtenerHistorialSolicitud(id),
    staleTime: 60_000,
  });

export function useHistorialSolicitud(id: string) {
  return useSuspenseQuery(historialSolicitudQueryOptions(id));
}
